import React from 'react';
import cx from 'classnames';
import Modal from '../../../../../components/Modal/Modal';
import Button from '../../../../../components/Button';
import InfoTable from '../../../../../components/table/InfoTable';
import { setDash } from '../../../../../lib/common';
import {
  INVALID_COUPON_BRAND_ITEM_EXCEL_UPLOAD_CASE_TEXT,
  INVALID_EXCEL_UPLOAD_COUPON_CASE_TEXT,
  VALID_EXCEL_UPLOAD_COUPON_CASE_TEXT,
} from '../../../../../constants/service/app/couponConstants';
import './ExcelUploadCouponBrandValidFailModal.scss';

const ExcelUploadCouponBrandValidFailModal = (props) => {
  const { isOpen, data, closeModal, onSubmit, handleDownloadInvalidItems } = props;
  const { brandList, requestCnt, possibleCnt, impossibleCnt } = data;

  return (
    <Modal
      title="쿠폰 사용 가능한 브랜드 엑셀 업로드 불가능"
      isOpen={isOpen}
      width={800}
      height={600}
      isFooter={true}
      okText="확인"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="excel-upload-coupon-brand-valid-fail-modal-wrap">
        <div className="excel-upload-coupon-brand-valid-fail-title">
          <div className="summary">
            <span className="request">
              요청:
              <span>{requestCnt}</span>
            </span>
            <span className="possible">
              가능:
              <span>{possibleCnt}</span>
            </span>
            <span className="impossible">
              불가능:
              <span>{impossibleCnt}</span>
            </span>
          </div>

          <div>엑셀 업로드에 실패했습니다.</div>
          <div>아래 리스트에서 실패한 결과를 확인하시고,</div>
          <div>
            <span>수정을 한 뒤 다시 시도해주세요.</span>
          </div>
        </div>

        <div className="download-section">
          <Button color="primary" onClick={handleDownloadInvalidItems} text="불가능 항목 다운로드" />
        </div>

        <div className="excel-upload-coupon-brand-valid-fail-list-section">
          <InfoTable>
            <thead>
              <tr>
                <th>순번</th>
                <th>유효성 검사 결과</th>
                <th className="invalid-message">브랜드 ID</th>
              </tr>
            </thead>
            <tbody>
              {brandList.map((item, index) => (
                <tr key={index}>
                  <td className="tc">{index + 1}</td>
                  <td className={cx('result', { isInvalid: item.brandIsInvalid })}>
                    {item.brandIsInvalid ? INVALID_EXCEL_UPLOAD_COUPON_CASE_TEXT : VALID_EXCEL_UPLOAD_COUPON_CASE_TEXT}
                  </td>
                  <td className="tc">
                    {setDash(item.brandId)}
                    <div className="message">
                      {item.brandIsInvalid
                        ? INVALID_COUPON_BRAND_ITEM_EXCEL_UPLOAD_CASE_TEXT[item.brandInvalidType]
                        : ''}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </InfoTable>
        </div>
      </div>
    </Modal>
  );
};

export default ExcelUploadCouponBrandValidFailModal;
